// extracted by mini-css-extract-plugin
export var label = "GroupLabel-module--label--3e549";